import CachedIcon from '@mui/icons-material/Cached'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Box, Breadcrumbs, Card, IconButton, Link, Paper, Stack, TableContainer, Typography } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import LoadingUI from '../../comman/LoadingUI'
import NoDataFound from '../../comman/NoDataFound'
import Appbar from '../../components/Appbar'
import DrawerUI from '../../components/Drawer'
import Body from '../../layout/Body'
import { getMissionLinkedQnsAction } from '../../redux/toolkit/mission/getMissionLinkedQns'
import { getUserMissionDetailsAction } from '../../redux/toolkit/mission/getUserMissionDetails'
import { useStyles } from '../../theme/theme'

const breadcrumb = (
    <Stack>
        <Breadcrumbs separator={<NavigateNextIcon sx={{ color: '#fff' }} fontSize="small" />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/'>Home</Link>
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/mission'>Mission</Link>
            <Link underline="hover" sx={{ color: "#fff" }} color='inherit' href='/mission-detail'>Mission details</Link>
        </Breadcrumbs >
        <Typography variant='h5'>Mission Details</Typography>
    </Stack >
)


export default function MissionDetails() {
    // state
    const dispatch = useDispatch()
    const mission_id = useLocation()?.search?.split("?")[1]

    const getMissionLinkedQns = useSelector(state => state.getMissionLinkedQns)
    const { data: getMissionLinkedQnsData, loading: getMissionLinkedQnsLoading } = getMissionLinkedQns
    const getUserMissionDetails = useSelector(state => state.getUserMissionDetails)
    const { data: getUserMissionDetailsData, loading: getUserMissionDetailsLoading } = getUserMissionDetails



    // console.log("getMissionLinkedQnsData", getMissionLinkedQnsData)

    const [pageSize, setPageSize] = useState(25);
    const classes = useStyles();


    const missionDetailsColumn = [
        {
            field: 's_no',
            headerName: 'S. No.',
            filterable: false,
            flex: 1,
            minWidth: 50,
            headerClassName: 'super-app-theme--header',
            renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1
        },
        {
            field: '_id',
            headerName: 'ID',
            flex: 1,
            minWidth: 250,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.user_id?._id}</Typography>
                )
            },
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.user_id?.name}</Typography>
                )
            },
        },
        {
            field: 'email',
            headerName: 'Email',
            flex: 1,
            minWidth: 250,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.user_id?.email}</Typography>
                )
            },
        },
        {
            field: 'mission_attempts2',
            headerName: 'Total Attempts',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.user_id?.mission_attempts}</Typography>
                )
            },
        },
        {
            field: 'mission_attempts1',
            headerName: 'Mission Complete',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.user_id?.mission_complete}</Typography>
                )
            },
        },
        {
            field: 'mission_attempts3',
            headerName: 'Mission Dropped',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.user_id?.mission_droped}</Typography>
                )
            },
        },
        {
            field: 'mission_attempts4',
            headerName: 'Mission Quit',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.user_id?.mission_droped}</Typography>
                )
            },
        },
        // {
        //     field: 'missions.status',
        //     headerName: 'Status',
        //     flex: 1,
        //     minWidth: 170,
        //     headerClassName: 'super-app-theme--header',
        //     renderCell: (params) => {
        //         return (
        //             <Typography>{params?.row?.missions?.[0]?.status}</Typography>
        //         )
        //     },
        // },
        {
            field: 'publisher_id.publisher_name',
            headerName: 'Publisher Name',
            flex: 1,
            minWidth: 150,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.publisher_id?.name}</Typography>
                )
            },
        },
    ]


    // fn
    const handleRefresh = () => {
        dispatch(getUserMissionDetailsAction({ mission_id: mission_id }))
    }

    // useEffect
    useEffect(() => {
        dispatch(getMissionLinkedQnsAction(mission_id))
        dispatch(getUserMissionDetailsAction(mission_id))
    }, [])

    return (
        <>
            <Helmet><title>Quick mission | Mission-detail</title></Helmet>
            <Appbar breadcrumb={breadcrumb} />
            <DrawerUI />
            <Body>

                <Card sx={{ p: 3, bgcolor: 'primary.main', color: '#fff' }}>
                    <Stack spacing={2}>
                        <Box>
                            <Typography variant='h6'>Linked Questions</Typography>
                            <Box sx={{ my: 1, ml: 1 }}>
                                {getMissionLinkedQnsLoading ? <LoadingUI /> :
                                    getMissionLinkedQnsData?.map((item, index) => {
                                        return (
                                            <Stack key={index} sx={{ my: 2 }}>
                                                <Stack direction={'row'} alignItems='center'>
                                                    <Typography sx={{ color: 'yellow' }}>Question : </Typography>
                                                    <Typography sx={{ ml: 1 }} variant='subtitle2'>{item?.question}</Typography>
                                                </Stack>
                                                <Stack direction={'row'} alignItems='center'>
                                                    <Typography sx={{ color: 'yellow' }}> Answer Options :</Typography>
                                                    {item?.options?.map((item, i) => {
                                                        const style = item && item.correct===true ? { color: "green" } : { color: "white" };
                                                        return <Typography sx={{ ml: 1 }} key={i} style={style}>{item.option}</Typography>
                                                    })}
                                                </Stack>
                                            </Stack>
                                        )
                                    })}
                            </Box>
                        </Box>
                    </Stack>
                </Card>


                {/* <Card sx={{ mt: 2, p: 2 }}>
                    <Typography variant='h6'>Get Complete Mission By Users</Typography>
                    <Stack direction={'row'} alignItems='center' spacing={2}>
                        {noOfQualifiedMissionLoading ? <LoadingUI /> : <Typography variant='h4' color='primary'>{noOfQualifiedMissionData?.complete_mission_users || "--"}</Typography>}
                    </Stack>

                    <Button sx={{ mt: 1 }} onClick={handlenoOfQualifiedMission} variant='contained'>Get Users Data</Button>
                </Card> */}



                <Card sx={{ mt: 2, }}>
                    <TableContainer>
                        <Stack direction={'row'} justifyContent='space-between' alignItems={'center'}>
                            <Typography sx={{ ml: 3, my: 2 }} variant='h6'>User List</Typography>
                            <IconButton sx={{ mr: 3, my: 2 }} onClick={handleRefresh}><CachedIcon /></IconButton>
                        </Stack>

                        <Paper sx={{
                            bgcolor: '#fff',
                            '& .super-app-theme--header': {
                                bgcolor: '#071D45',
                                color: '#fff',
                            },
                        }} elevation={0}>
                            <DataGrid
                                className={classes.root}
                                getRowHeight={() => 'auto'}
                                sx={{ border: 0 }}
                                autoHeight
                                rows={getUserMissionDetailsData}
                                columns={missionDetailsColumn}
                                getRowId={(row) => row._id}
                                disableSelectionOnClick
                                experimentalFeatures={{ newEditingApi: true }}
                                pagination
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                rowsPerPageOptions={[25, 50, 100]}
                                disableColumnSelector
                                loading={getUserMissionDetailsLoading ? <LoadingUI /> : false}
                                components={{
                                    NoRowsOverlay: () => <NoDataFound />,
                                    Toolbar: GridToolbar,
                                }}

                            />
                        </Paper>
                    </TableContainer>
                </Card>

            </Body>
        </>
    )
}
